import { parseJWT } from './jwt';

export function persistAuthSession({ access_token: accessToken, user, plan }) {
    if (!accessToken) {
        return;
    }

    localStorage.setItem('access_token', accessToken);
    const decodedToken = parseJWT(accessToken) || {};
    const planName = plan?.name ?? user?.plan_name ?? 'Free';

    const storedUser = {
        name: user?.name ?? decodedToken.name ?? '',
        email: user?.email ?? decodedToken.email ?? '',
        profile_picture: user?.profile_picture ?? decodedToken.profile_picture,
        store_name: user?.store_name ?? decodedToken.store_name,
        whatsapp: user?.whatsapp ?? decodedToken.whatsapp,
        site: user?.site ?? decodedToken.site,
        instagram: user?.instagram ?? decodedToken.instagram,
        tiktok: user?.tiktok ?? decodedToken.tiktok,
        plan_name: planName,
        is_master: Boolean(user?.is_master),
    };

    localStorage.setItem('user', JSON.stringify(storedUser));
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('acompanha:user-updated', { detail: storedUser }));
    }
}

export function readStoredUser() {
    try {
        const raw = localStorage.getItem('user');
        if (!raw) {
            return null;
        }
        return JSON.parse(raw);
    } catch {
        return null;
    }
}

export function isMasterUser(user = readStoredUser()) {
    return Boolean(user?.is_master);
}

export function patchStoredUser(partial) {
    const current = readStoredUser() || {};
    const next = { ...current, ...partial };
    localStorage.setItem('user', JSON.stringify(next));
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('acompanha:user-updated', { detail: next }));
    }
    return next;
}
